export default __webpack_public_path__ + "static/media/caddieLogo.27f43aa0.png";